import { LOCAL_STORAGE_KEYS } from 'utils/constants/localStorageKeys';

export const isSuperUser = () => localStorage.getItem(LOCAL_STORAGE_KEYS.SUPER_USER) === 'true';
